import getElementSelectors from '../shares/lib/getElementSelectors';
import { getSDKConfig } from '../shares/lib/getSDKConfig';
import selectGameFromDropdown from '../features/selectGameFromDropdown';
import { getLocalStore } from '../shares/lib/localStore';
import { LocalStoreKeys } from '../shares/enums/localStoreKeys';
import { SwipeGamesItem } from '../shares/model/swipe';
import swipeSdkStyles from '../../../public/assets/css/swipe-styles.css?inline';

export const createDropdownFromGameList = async (): Promise<void> => {
  const { dropdownMenu } = getElementSelectors();
  const swipeSDKConfig = getSDKConfig();

  const styleElement = document.createElement('style');
  let cssContent = ``;

  if (swipeSDKConfig?.swipeGames?.styles) {
    cssContent += `.swipe-ctr .swipe-control {
        background-color: ${swipeSDKConfig.swipeGames?.styles.iconBgColor ?? 'transparent'};
        top: ${swipeSDKConfig.swipeGames?.styles.iconTop ?? 0}%;
    }\n`;
  }

  cssContent += `.swipe-ctr .swipe-control__item.sports {
        background-image: url(${process.env.NX_HOST}/assets/img/swipe__football.svg);
    }\n`;

  swipeSDKConfig?.swipeGames?.gameListConfig.gameList?.forEach(
    (game: SwipeGamesItem) => {
      cssContent += `.swipe-ctr .swipe-control__item.game_icon_${game?.gameId} {
            background-image: url(${game?.gameIconUrl});
            border-radius: 50%;
            background-size: cover;
            background-repeat: no-repeat;
        }\n`;

      cssContent += `#swipe-sdk-container .dropdown__toggle.game_${game?.gameId}:after, #swipe-sdk-container .dropdown__item.game_${game?.gameId}:after {
        background-image: url(${game?.gameDropdownUrl});
    }\n`;

      if (game?.colorGradient?.length > 0) {
        cssContent += `#swipe-sdk-container .dropdown__toggle.game_${game?.gameId},#swipe-sdk-container  .dropdown__item.game_${game?.gameId} {
                background: -webkit-gradient( linear, left top, left bottom, from(${game?.colorGradient[0]}), to(${game?.colorGradient[1]}));
                background: -o-linear-gradient(${game?.colorGradient[0]}, ${game?.colorGradient[1]});
                background: linear-gradient(${game?.colorGradient[0]}, ${game?.colorGradient[1]});
                position: relative;
            }\n`;
      }

      const gameDiv = document.createElement('div');
      gameDiv.setAttribute('data-game-id', `${game?.gameId}`);
      gameDiv.classList.add('dropdown__item', `game_${game?.gameId}`);

      const currentGameselected = getLocalStore(
        `${LocalStoreKeys.SELECTED_GAME}`,
      );
      // eslint-disable-next-line eqeqeq
      if (currentGameselected?.currentGameId == game?.gameId) {
        gameDiv.classList.add('hidden');
      }

      dropdownMenu?.appendChild(gameDiv);
    },
  );

  styleElement.appendChild(document.createTextNode(swipeSdkStyles));

  styleElement.appendChild(document.createTextNode(cssContent));

  document.head.appendChild(styleElement);

  selectGameFromDropdown();
  removeDrawerUI();
};

const removeDrawerUI = (): void => {
  const { topBar, drawer, drawerOverlay } = getElementSelectors();
  topBar?.remove();
  drawer?.remove();
  drawerOverlay?.remove();
};
